import React, { type FC } from 'react'

import { canMappingBeDeleted, canMappingBeDisabled, canMappingBeEnabled, Capability, type CybusDetailedMapping, Translation } from '../../../../domain'

import { DeleteIcon, EnableIcon, PauseIcon } from '../../common'
import { DetailsActionButton } from '../../Details'
import { useAppUsecases } from '../../State'

export const HeaderActions: FC<{ resource: CybusDetailedMapping }> = ({ resource: { id, status } }) => {
    const { bulkDeleteMappingsUsecase, bulkEnableMappingsUsecase, bulkDisableMappingsUsecase } = useAppUsecases()

    return (
        <>
            <DetailsActionButton
                data-testid={canMappingBeDisabled({ status }) ? 'disable-mapping-button' : 'enable-mapping-button'}
                disabled={!canMappingBeDisabled({ status }) && !canMappingBeEnabled({ status })}
                text={canMappingBeDisabled({ status }) ? Translation.DISABLE : Translation.ENABLE}
                capabilities={[Capability.MAPPINGS_MANAGE]}
                onClick={canMappingBeDisabled({ status })
                    ? () => bulkDisableMappingsUsecase.selectMappings([id])
                    : () => bulkEnableMappingsUsecase.selectMappings([id])}
                startIcon={canMappingBeDisabled({ status }) ? <PauseIcon /> : <EnableIcon />}
                showText
            />

            <DetailsActionButton
                disabled={!canMappingBeDeleted({ status })}
                data-testid="delete-mapping-button"
                text={Translation.DELETE}
                capabilities={[Capability.MAPPINGS_MANAGE]}
                onClick={() => bulkDeleteMappingsUsecase.selectMappings([id])}
                startIcon={<DeleteIcon />}
                variant="dangerOutline"
            />
        </>
    )
}
